import { createSlice } from '@reduxjs/toolkit';

const meTicketData = createSlice({
  name: 'meTicketData',
  initialState: { plan: undefined, isNoPeriodData: false },
  reducers: {
    setPlan(state, { payload }) {
      state.plan = payload;
    },
    setIsNoPeriodData(state, { payload }) {
      state.isNoPeriodData = payload;
    }
  }
});

export const { setPlan, setIsNoPeriodData } = meTicketData.actions;
export default meTicketData.reducer;
